import script from "./InterPhoneInput.vue?vue&type=script&setup=true&lang=js"
export * from "./InterPhoneInput.vue?vue&type=script&setup=true&lang=js"

import "./InterPhoneInput.vue?vue&type=style&index=0&id=3f358d7c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f358d7c"]])

export default __exports__